import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Button/External_link">
        <mask id="mask0_1426_4962" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="1" y="1" width="14" height="14">
          <path
            id="Icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.80968 1.59998H7.90479C8.29753 1.59998 8.6159 1.91835 8.6159 2.31109C8.6159 2.70382 8.29753 3.0222 7.90479 3.0222H5.80968C4.27702 3.0222 3.03026 4.28532 3.03026 5.84863L3.02232 10.1518C3.02232 11.7144 4.26967 12.9778 5.80333 12.9778H10.1977C11.7306 12.9778 12.9779 11.7143 12.9779 10.1518V9.0719C12.9779 8.67917 13.2962 8.36079 13.689 8.36079C14.0817 8.36079 14.4001 8.67917 14.4001 9.0719V10.1518C14.4001 12.4957 12.5202 14.4 10.1977 14.4H5.80333C3.48012 14.4 1.6001 12.4959 1.6001 10.1505L1.60804 5.84732C1.60804 3.50397 3.48737 1.59998 5.80968 1.59998ZM10.8445 2.54814H13.6886H13.6889C13.8045 2.54814 13.9138 2.57574 14.0103 2.62473C14.0448 2.64223 14.0782 2.66274 14.1101 2.68625C14.2859 2.81571 14.4 3.02416 14.4 3.25925V6.10369C14.4 6.49643 14.0816 6.8148 13.6889 6.8148C13.2962 6.8148 12.9778 6.49643 12.9778 6.10369V4.97594L8.50276 9.45097C8.22505 9.72868 7.7748 9.72868 7.49709 9.45097C7.21939 9.17326 7.21939 8.72301 7.49709 8.44531L11.972 3.97036H10.8445C10.4517 3.97036 10.1333 3.65198 10.1333 3.25925C10.1333 2.86651 10.4517 2.54814 10.8445 2.54814Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask0_1426_4962)">
          <g id="Color">
            <rect x="1.6001" y="1.59998" width="12.8" height="12.8" fill="black" />
            <rect x="1.6001" y="1.59998" width="12.8" height="12.8" fill="black" fill-opacity="0.2" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Icon;
